import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '@act/shared/constants';
import { useLanguage } from '@act/storybook';
import { useTranslation } from 'react-i18next';
import { LanguageSelectorUI, ToggleSwitch } from '@act/storybook';
import { useEffect } from 'react';

interface LanguageSelectorProps {
  useToggleSwitch?: boolean;
}

const LanguageSelector = ({
  useToggleSwitch = false,
}: LanguageSelectorProps) => {
  // Subscribe to i18next language changes to trigger re-renders
  useTranslation();
  const { currentLanguage: selectedLanguage, setLanguage } = useLanguage();

  // Find the current language directly from the provider state
  const currentLanguage = SUPPORTED_LANGUAGES.find(
    lang => lang.i18nCode === selectedLanguage
  );

  // If no valid language is found, default to English
  useEffect(() => {
    if (!currentLanguage && selectedLanguage) {
      setLanguage(DEFAULT_LANGUAGE.i18nCode);
    }
  }, [currentLanguage, selectedLanguage, setLanguage]);

  const onChangeFunction = (value: string) => {
    const i18nCode = SUPPORTED_LANGUAGES.find(
      lang => lang.code === value
    )?.i18nCode;
    if (i18nCode) {
      setLanguage(i18nCode);
    }
  };

  if (useToggleSwitch) {
    return (
      <ToggleSwitch
        options={[
          { label: 'English', value: 'en-US' },
          { label: 'Spanish', value: 'es' },
        ]}
        value={selectedLanguage || DEFAULT_LANGUAGE.i18nCode}
        onChange={value => {
          onChangeFunction(value.split('-')[0]);
        }}
      />
    );
  }

  return (
    <LanguageSelectorUI
      value={currentLanguage?.code || DEFAULT_LANGUAGE.code}
      onChange={onChangeFunction}
    />
  );
};

export default LanguageSelector;
